import React, { useEffect, useState } from 'react'
import {useNavigate} from 'react-router-dom'
import git from 'isomorphic-git'
import FS from '@isomorphic-git/lightning-fs'
import {ReadCommitResult} from 'isomorphic-git'
import {faCodeBranch} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {getTimeFromNow} from '../../../functions/time'
import styles from "./index.module.scss"

interface BranchDetailsRowProps {
  fs: FS
  gitDir: string
  branch: string
  viewDetails?: boolean
}

export const BranchDetailsRow = (props: BranchDetailsRowProps) => {
  const { fs, gitDir: gitdir, branch, viewDetails } = props
  const [commit, setCommit] = useState<ReadCommitResult>()
  const navigate = useNavigate()

  useEffect(() => {
    fs && gitdir && git.resolveRef({ fs, gitdir, ref: branch })
      .then((oid) => git.readCommit({ fs, gitdir, oid }))
      .then(setCommit)
  }, [fs, gitdir, branch])

  const onClick = () => navigate('../codes/tree/' + branch)

  return (
    <div className={styles.Container}>
      <div className={styles.Content}>
        <div>
          <FontAwesomeIcon icon={faCodeBranch} />
          <p className={styles.Title}>{branch}</p>
        </div>
        <div>
          <p className={styles.Message}>
            {commit && `${commit.commit.message}, ${getTimeFromNow(commit.commit.committer.timestamp)} by `}
          </p>
          <u className={styles.Message}>{commit && commit.commit.committer.name}</u>
        </div>
      </div>
      {viewDetails === true && <button 
        className={styles.Button}
        onClick={onClick}
      >VIEW VERSION</button>}
    </div>
  )
}